import { captureException } from '../logging/logger';

export default function initOneTrustPreferenceButtons(): void {
    document.querySelectorAll<HTMLButtonElement>( '[data-action="open-cookie-preferences"]' ).forEach( ( btn: HTMLButtonElement ) => {
        btn.addEventListener( 'click', ( event: Event ) => {
            if ( !window.OneTrust ) {
                captureException( 'cannot launch OneTrust preferences as js is missing' );
                return;
            }
            window.OneTrust.ToggleInfoDisplay();
        } );
    } );
}

export function isConsentBannerVisible(): boolean {
    const banner = document.querySelector<HTMLElement>( '#onetrust-banner-sdk' );

    if ( !banner ) {
        return false;
    }

    return banner.style.display !== 'none';
}

export function isContentPreferencesVisible(): boolean {
    const popup = document.querySelector<HTMLElement>( '#onetrust-pc-sdk' );

    if ( !popup ) {
        return false;
    }

    return popup.style.display !== 'none';
}
